import { primary, secondary } from '../core/palette';

// ----------------------------------------------------------------------

export const primaryColorPresets = {
  default: {
    lighter: primary.lighter,
    light: primary.light,
    main: primary.main,
    dark: primary.dark,
    darker: primary.darker,
    contrastText: primary.contrastText,
  },
  preset4: {
    lighter: '#5af2a8',
    light: '#11d476',
    main: '#0d9d57',
    dark: '#0b8e4f',
    darker: '#085e34',
    contrastText: '#FFFFFF',
  },
};

export const secondaryColorPresets = {
  default: {
    lighter: secondary.lighter,
    light: secondary.light,
    main: secondary.main,
    dark: secondary.dark,
    darker: secondary.darker,
    contrastText: secondary.contrastText,
  },

  preset4: {
    lighter: '#cbd8e6',
    light: '#98b2cd',
    main: '#7f9fc1',
    dark: '#648bb4',
    darker: '#3a5878',
    contrastText: '#FFFFFF',
  },
};
